import { Box, Typography } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { PATHS } from '../../config/consts';
import { LoginFlowsWrapper } from '../_components/LoginFlowsWrapper/LoginFlowsWrapper';
import { RouterLink } from '../ResetPasswordPage/components/Link/PrimaryLink';
import messages from './messages';
import { RegisterForm } from './RegisterForm';
import { SuccessMessage } from './SuccessMessage';
import { useRegister } from './useRegister';

export function Register() {
  const { formatMessage, formData, isFetching, isOryRegistrationFFEnabled, isRegistrationFinished, register } =
    useRegister();

  const loginLink = (
    <Typography component="div">
      <FormattedMessage
        {...messages.RegisterImsSubtitle}
        values={{
          link: (chunks) => (
            <RouterLink styles={{ display: 'inline' }} to={PATHS.LOGIN}>
              {chunks}
            </RouterLink>
          ),
        }}
      />
    </Typography>
  );

  return (
    <Box sx={{ backgroundColor: 'background.paper' }}>
      <LoginFlowsWrapper
        title={formatMessage(messages.RegisterImsTitle, { br: <br /> })}
        subTitle={isRegistrationFinished ? undefined : loginLink}
      >
        {isRegistrationFinished ? (
          <SuccessMessage email={formData.getValues('email')} />
        ) : (
          <FormProvider {...formData}>
            <form onSubmit={formData.handleSubmit(register)}>
              <RegisterForm isOryRegistrationFFEnabled={isOryRegistrationFFEnabled} isLoading={isFetching} />
            </form>
          </FormProvider>
        )}
      </LoginFlowsWrapper>
    </Box>
  );
}
